import { apiFetch } from './api';

/**
 * List admin notifications
 * @param {Object} params - Query parameters (read, type, category, page, limit)
 * @returns {Promise<Object>}
 */
export async function listNotifications(params = {}) {
  try {
    const queryParams = new URLSearchParams();
    if (params.read !== undefined) queryParams.append('read', params.read);
    if (params.type) queryParams.append('type', params.type);
    if (params.category) queryParams.append('category', params.category);
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    
    const queryString = queryParams.toString();
    const response = await apiFetch(`/api/admin/notifications${queryString ? `?${queryString}` : ''}`);
    
    return {
      success: response.success !== undefined ? response.success : true,
      data: response.data || response
    };
  } catch (error) {
    console.error('Error listing notifications:', error);
    return {
      success: false,
      error: error.data?.error || error.message || 'Failed to list notifications',
      data: { notifications: [], pagination: { total: 0, page: 1, limit: 50, pages: 0 }, unreadCount: 0 }
    };
  }
}

/**
 * Mark notification as read
 * @param {String} notificationId - Notification ID
 * @returns {Promise<Object>}
 */
export async function markNotificationAsRead(notificationId) {
  try {
    const response = await apiFetch(`/api/admin/notifications/${notificationId}/read`, {
      method: 'PATCH'
    });
    return {
      success: response.success !== undefined ? response.success : true,
      data: response.data || response
    };
  } catch (error) {
    console.error('Error marking notification as read:', error);
    return {
      success: false,
      error: error.data?.error || error.message || 'Failed to mark notification as read'
    };
  }
}

/**
 * Mark all notifications as read
 * @returns {Promise<Object>}
 */
export async function markAllNotificationsAsRead() {
  try {
    const response = await apiFetch('/api/admin/notifications/read-all', {
      method: 'PATCH'
    });
    return {
      success: response.success !== undefined ? response.success : true,
      data: response.data || response
    };
  } catch (error) {
    console.error('Error marking all notifications as read:', error);
    return {
      success: false,
      error: error.data?.error || error.message || 'Failed to mark all notifications as read'
    };
  }
}






